import { cn } from '@/lib/utils';
import {
  CheckCircle, MapPin, Thermometer, Scale, Package,
} from 'lucide-react';

const CAPABILITIES = [
  { key: 'has_gps', label: 'GPS Tracking', icon: MapPin, desc: 'Real-time location tracking' },
  { key: 'has_temperature', label: 'Temperature Sensor', icon: Thermometer, desc: 'Cold chain monitoring' },
  { key: 'has_humidity', label: 'Humidity Sensor', icon: Package, desc: 'Moisture level detection' },
  { key: 'has_weight', label: 'Weight Sensor', icon: Scale, desc: 'Load cell for package weight' },
  { key: 'has_bag_sensor', label: 'Bag Open Sensor', icon: Package, desc: 'Tamper detection' },
];

export function DeviceStep2Capabilities({ formData, onChange }) {
  return (
    <div className="space-y-4">
      <p className="text-sm text-slate-600 dark:text-slate-400 mb-4">
        Select the hardware capabilities of this device:
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {CAPABILITIES.map((cap) => {
          const Icon = cap.icon;
          const isChecked = formData[cap.key];
          return (
            <div
              key={cap.key}
              onClick={() => onChange(cap.key, !isChecked)}
              className={cn(
                'flex items-start gap-3 p-4 rounded-lg border text-left transition-all cursor-pointer',
                isChecked
                  ? 'bg-blue-50 dark:bg-blue-900/20 border-blue-300 dark:border-blue-700'
                  : 'bg-white dark:bg-slate-700 border-slate-200 dark:border-slate-600 hover:border-blue-300 dark:hover:border-blue-600',
              )}
            >
              <div className={cn(
                'w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0',
                isChecked ? 'bg-blue-600 text-white' : 'bg-slate-100 dark:bg-slate-600 text-slate-500 dark:text-slate-400',
              )}>
                <Icon className="w-5 h-5" />
              </div>
              <div className="flex-1">
                <p className={cn('font-medium', isChecked ? 'text-blue-700 dark:text-blue-400' : 'text-slate-700 dark:text-slate-300')}>{cap.label}</p>
                <p className="text-xs text-slate-500 dark:text-slate-400">{cap.desc}</p>
              </div>
              <div className={cn(
                'w-5 h-5 rounded border-2 flex items-center justify-center mt-1 flex-shrink-0',
                isChecked ? 'bg-blue-600 border-blue-600' : 'border-slate-300 dark:border-slate-500',
              )}>
                {isChecked && <CheckCircle className="w-3 h-3 text-white" />}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
